export default {"src":"/_next/static/media/circle_icon_person_40.99c36a67.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};